import {
  parseSearchArrayValue,
  parseSearchBooleanValue,
  parseSearchNumberValue,
  parseSearchStringValue,
} from 'infrastructure/functions/parse-query-string';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';
import { type TPotentialPatientsCountFilter } from 'infrastructure/hooks/patient/use-get-potential-transfer-count';

import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';

const defaultFilter: TPotentialPatientsCountFilter = {};

const parseFunctions: TParseFunctions<TPotentialPatientsCountFilter> = {
  fromAgencyDoctorGuid: parseSearchStringValue,
  toAgencyDoctorGuid: parseSearchStringValue,
  fromName: parseSearchStringValue,
  toName: parseSearchStringValue,

  clinicGuid: parseSearchArrayValue,
  parentClinicGuid: parseSearchArrayValue,

  language: parseSearchStringValue,

  ccm: parseSearchBooleanValue,
  pcm: parseSearchBooleanValue,
  newlyEnrolledOnly: parseSearchBooleanValue,
  followUpOnly: parseSearchBooleanValue,
  partialsOnly: parseSearchBooleanValue,

  selectedPatientsCount: parseSearchNumberValue,
  patientsCountToTransfer: parseSearchNumberValue,
};

export const usePotentialPatientsFilter = () => {
  return useQueryFilterNew<TPotentialPatientsCountFilter>(
    defaultFilter,
    parseFunctions,
    ['patientsCountToTransfer'],
  );
};
